// @ts-nocheck
import { toastTypes } from '../../enums';
import { createOAuthIntegrationStore } from './_shared';

export default createOAuthIntegrationStore({
  partnerKey: 'Pipedrive',
  defaultConfigs: { enabled: false },
  toastKeys: { update: toastTypes.pipedriveUpdateConfigs },
});
